import * as moment from 'moment';
import { WebStorage } from '../components/auth/storage/web.storage';

export class Common {
    // TIMEZONE FIX: Changed from 'UTC' to 'Asia/Calcutta' to fix midnight transition issues
    // Previously inconsistent timezone usage caused dates to be off by one day during 12:00 AM - 2:00 AM
    static timeZone: string = 'America/New_York';
    static currentTime = moment().format('HH:mm:ss');
    static currentDate = moment().format('YYYY-MM-DD');
    static format: string = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
    constructor() {}

    static isObjectEmpty(value: Object | any[] | null | undefined): boolean {
        return (
            value === null ||
            value === undefined ||
            value === '' ||
            Object.keys(value).length === 0
        );
    }

    static isEmpty(value: string | any[] | null | undefined): boolean {
        return (
            value === null ||
            value === undefined ||
            value === '' ||
            value === ' ' ||
            value.length === 0
        );
    }

    static isNotEmpty(value: string | any[] | null | undefined): boolean {
        return !Common.isEmpty(value);
    }

    static findById(id: any, items: any[]) {
        items.filter((item) => {
            return item.id === id;
        });
        return null;
    }

    static setSelected(obj: { selected: boolean }) {
        if (obj.selected) {
            obj.selected = false;
        } else {
            obj.selected = true;
        }
    }

    static getNextDate(inputDate: Date): string {
        return new Date(
            new Date(inputDate).getTime() + 60 * 60 * 18 * 1000
        ).toJSON();
    }

    static getTodaysDate(inputDate: Date): string {
        return new Date(
            new Date(inputDate).getTime() + 60 * 60 * 12 * 1000
        ).toJSON();
    }

    static getUtcDayRange(dateStr: string): { startUtc: string, endUtc: string } {
        const startUtc = moment.tz(dateStr, Common.timeZone).startOf('day').utc().toISOString();
        const endUtc = moment.tz(dateStr, Common.timeZone).endOf('day').utc().toISOString();
        return { startUtc, endUtc };
    }

    static getUtcDateRange(start: string | Date, end: string | Date | null): { startUtc: string; endUtc: string } {
        const startMoment = moment.tz(start, Common.timeZone).startOf('day').utc().toISOString();
        const endMoment = end
          ? moment.tz(end, Common.timeZone).endOf('day').utc().toISOString()
          : moment.tz(start, Common.timeZone).endOf('day').utc().toISOString();
        return {
          startUtc: startMoment,
          endUtc: endMoment,
        };
    }


    static convertLocalDateToUTC(dateString: string): string {
        if (!dateString) return '';
      
        const schoolTimeZone = Common.timeZone; 
        const currentSchoolTime = moment().tz(schoolTimeZone).format('HH:mm:ss.SSS');
        const schoolDateTime = `${dateString}T${currentSchoolTime}`;      
        const utcDateTime = moment.tz(schoolDateTime, schoolTimeZone).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      
        return utcDateTime;
      }

    static getUtcStartOfDay(date: string | Date,): string {
        return moment.tz(date, Common.timeZone).startOf('day').utc().toISOString();
    }

    static getUtcEndOfDay(date: string | Date): string {
        return moment.tz(date, Common.timeZone).endOf('day').utc().toISOString();
    }

    static getUtcStartOfDayForRecurring(date: string | Date,): string {
        const momentDate = moment(date);
        const dateStr = momentDate.format('YYYY-MM-DD');
        return moment.tz(dateStr + ' 00:00:00', Common.timeZone).utc().toISOString();
    }

    static getUtcEndOfDayForRecurring(date: string | Date): string {
        const momentDate = moment(date);
        const dateStr = momentDate.format('YYYY-MM-DD');
        return moment.tz(dateStr + ' 23:59:59.999', Common.timeZone).utc().toISOString();
    }
    

    static momentTimeZoneDate(date: any): string {
        return moment.utc(date).tz(Common.timeZone).format('YYYY-MM-DD');
    }

    static momentNewTimeZoneDate(date: any): string {
        // Preserve local date without timezone conversion to prevent day shifts
        // This ensures the date shown matches what the user selected
        return moment.utc(date).format('YYYY-MM-DD');
    }

    static momentEditTimeZoneDate(date: any): string {
        // Preserve local date without timezone conversion to prevent day shifts
        // This ensures the date shown matches what the user selected
        return moment(date).format('YYYY-MM-DD');
    }

    static momentCurrentDate(): string {
        const schoolTimeZone = Common.timeZone;
    
        const schoolNow = moment().tz(schoolTimeZone);
    
        const utcDateTime = schoolNow.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    
        return utcDateTime;
    }

    static formatUtcDateForInput(dateStr: string): string {
        return moment.utc(dateStr).tz(Common.timeZone).format("YYYY-MM-DD") || '';
    }

    static momentTimerZoneTime(): string {
        return moment.utc().format(Common.format);
    }

    static momentTimeZoneTime(date: any): string {
        return moment.utc(date).tz(Common.timeZone).format('HH:mm');
    }

    static parseDate(timestamp: string) {
        const date = moment(timestamp).tz(Common.timeZone);
        return date.format('hh:mm A');
    }

    static removeEmptyFields(obj: any) {
        Object.keys(obj).forEach((key) => {
            if (Common.isEmpty(obj[key])) {
                delete obj[key];
            }
        });
    }

    static toTitleCase(str: string): string {
        return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    }

    static paramMethod(req: any): any {
        let options: boolean = false;
        if (req) {
            if (
                req['fullName.contains'] ||
                req['staffName.contains'] ||
                req['studentName.contains'] ||
                req['name.contains'] ||
                req['firstName.contains'] ||
                req['staffId.equals'] ||
                req['studentId.equals'] ||
                req['refTable.equals']
                // req.hasOwnProperty('activated.equals')
            ) {
                options = true;
            }
            return options;
        }
    }

    static isPositive(number: number) {
        // Check if the number is a valid number and greater than zero
        return typeof number === 'number' && number > 0;
    }

    static setTimeZone(timeZone: string) {
        return (Common.timeZone = timeZone);
    }

    static isSameMonthInTimezone(dateToCheck: Date | string): boolean {
        // Get the current date in the specified time zone
        const nowInTimezone = moment().tz(Common.timeZone);
        // Convert the dateToCheck to the specified time zone
        const dateToCheckInTimezone = moment(dateToCheck).tz(Common.timeZone);
        // Check if the dates are in the same month and year
        return dateToCheckInTimezone.isSame(nowInTimezone, 'month');
    }

    static getStartOfPreviousMonth(): string {
        return moment()
            .tz(Common.timeZone)
            .subtract(1, 'month')
            .startOf('month')
            .format('YYYY-MM-DDTHH:mm:ssZ');
    }

    static getStartOfPreviousMonthBilling(): string {
        return moment()
            .subtract(1, 'month') // Go back one month from today
            .startOf('month') // Move to the first day of that month
            .format('YYYY-MM-DDT00:00:00');
    }

    static convertToUTC(date: Date): Date {
        const timezone = Common.timeZone;
        if (!timezone) {
            throw new Error('Timezone not set');
        }
        const targetTimezoneOffset = this.getTimezoneOffset(timezone);
        const localTimezoneOffset = date.getTimezoneOffset();
        const targetTime =
            date.getTime() +
            (localTimezoneOffset - targetTimezoneOffset) * 60000;
        return new Date(targetTime);
    }

    static getTimezoneOffset(timezone: string): number {
        // Use moment-timezone to get the timezone offset
        const now = moment().tz(timezone);
        return now.utcOffset();
    }

    static isPreviousDate(selectedDate: string): boolean {
        const currentDate = moment().tz(Common.timeZone);
        const nextMonthLastDate = moment(currentDate)
            .add(1, 'month')
            .endOf('month');
        const selectedMoment = moment.tz(selectedDate, Common.timeZone);
        return selectedMoment.isSameOrBefore(nextMonthLastDate, 'day');
    }

    static findNthLastDayOfMonth(date: Date): string {
        let momentDate = moment(date);
        let lastDayOfMonth = momentDate.clone().endOf('month').date();
        let dayOfMonth = momentDate.date();

        if (dayOfMonth === lastDayOfMonth) {
            return '0';
        } else {
            let nthLast = lastDayOfMonth - dayOfMonth;
            return `-${nthLast}`;
        }
    }
    static getDayOfSelectedDate(date: Date | string): string {
        // Convert the date to a moment object using the specified timezone
        const momentDate = moment(date).tz(Common.timeZone);
        // Get the day of the week (0 - Sunday, 6 - Saturday)
        const dayOfWeek = momentDate.format('dddd'); // Returns day in full, e.g., "Monday"
        return dayOfWeek;
    }

    static formatDateTime(timestamp: string) {
        const date = moment(timestamp).tz(Common.timeZone);
        const day = date.format('D');
        const daySuffix = this.getDaySuffix(parseInt(day));
        return date.format(`D[${daySuffix}] MMM. YYYY | hh:mm A`);
    }

    private static getDaySuffix(day: number): string {
        if (day > 3 && day < 21) return 'th'; // Handle 11th to 19th
        switch (day % 10) {
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    }

    static convertToUTCString(dateInput: string | Date): string {
        const date = new Date(dateInput);

        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth();
        const utcDay = date.getUTCDate();
        const utcHours = date.getUTCHours();
        const utcMinutes = date.getUTCMinutes();
        const utcSeconds = date.getUTCSeconds();

        // Create clean UTC date object
        const cleanUTCDate = new Date(
            Date.UTC(
                utcYear,
                utcMonth,
                utcDay,
                utcHours,
                utcMinutes,
                utcSeconds
            )
        );

        return cleanUTCDate.toISOString();
    }

    static getDefaultDateRangeThisMonth(): [Date, Date] {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        return [firstDay, lastDay];
    }

    private static readonly profileBackgroundColors: string[] = [
        '#80A3DC',
        '#FDCD16',
        '#fda758',
        '#F67EAF',
        '#CB9AFC',
        '#94D1BE',
        '#FF9B9B',
        '#87CEEB',
        '#FFB5E8',
    ];

    static getInitials(name?: string): string {
        if (!name?.trim()) return '';
        const words = name.trim().split(/[-\s]+/);
        const firstLetter = words[0]?.[0]?.toUpperCase() || '';
        const secondLetter = words[1]?.[0]?.toUpperCase() || '';
        return `${firstLetter}${secondLetter}`.trim();
    }

    static getProfileMeta(
        name?: string,
        id?: number
    ): { initials: string; backgroundColor: string } {
        const initials = this.getInitials(name);

        let backgroundColor = this.profileBackgroundColors[0];
        if (typeof id === 'number' && id > 0) {
            const index = id % this.profileBackgroundColors.length;
            backgroundColor = this.profileBackgroundColors[index];
        } else {
            const randomIndex = Math.floor(
                Math.random() * this.profileBackgroundColors.length
            );
            backgroundColor = this.profileBackgroundColors[randomIndex];
        }

        return { initials, backgroundColor };
    }

    static isAdminUserLogin(storage: WebStorage): boolean {        
        return storage.hasAnyAuthority([
            'Role Admin',
            'Role Director',
            'Role Owner',
        ]);
    }

    static normalizeStartOfDay(date: Date): string {
        const d = new Date(date);
        d.setUTCHours(0, 0, 0, 0);
        return d.toISOString();
    }

    static normalizeEndOfDay(date: Date): string {
        const d = new Date(date);
        d.setUTCHours(23, 59, 59, 0);
        return d.toISOString();
    }

    static parseDateOnlyFromUTC(utcString: string): Date {
        if (!utcString) return new Date();
        const utcDate = moment.utc(utcString);
        return new Date(utcDate.year(), utcDate.month(), utcDate.date());
    }
}
